import { render, staticRenderFns } from "./UcBillingFrequencyDisplay.yaml?vue&type=template&id=246a16b9&component"
import script from "./UcBillingFrequencyDisplay.yaml?vue&type=script&lang=ts&component"
export * from "./UcBillingFrequencyDisplay.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports